import axios from 'axios';

export default {
    postAnalytics (data) {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') return Promise.resolve({ data: true });
        axios.post('/api/info', data);
    },
    postAnalyticSync (analyticsData, token) {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') return;
        var client=new XMLHttpRequest;
        client.open("POST","/api/info/", false);
        client.setRequestHeader("content-type","application/json");
        client.setRequestHeader("Authorization","Bearer " + token);
        client.send(JSON.stringify(analyticsData));

    }
};
